// Where each NATIONAL base map has tiles — same boxes as the mobile app (packages/core/src/mapCoverage.ts),
// under the web layer keys; spec/contracts/mobile_parity_spec.rb keeps them identical. A layer absent here
// is a world map. Boxes, not coastlines: generous on purpose near borders.
import {MapLayers} from '@js/components/modules/constants';

// [west, south, east, north] in degrees.
const IGN_AREAS = [
    [-5.3, 41.3, 9.7, 51.15], // metropolitan France + Corsica
    [-61.9, 15.8, -60.9, 16.6], // Guadeloupe
    [-61.3, 14.3, -60.7, 14.95], // Martinique
    [-54.7, 2.1, -51.5, 5.85], // French Guiana
    [55.1, -21.45, 55.9, -20.8], // Réunion
    [44.9, -13.1, 45.35, -12.6] // Mayotte
];

const COVERAGE = {
    os_maps: [[-10.76, 49.53, 1.93, 61.01]], // Great Britain
    swiss_topo: [[5.9, 45.8, 10.6, 47.85]], // Switzerland (+ Liechtenstein)
    usgs_topo: [
        [-125.0, 24.3, -66.8, 49.5], // contiguous United States
        [-180.0, 51.0, -129.0, 71.6], // Alaska
        [-160.5, 18.8, -154.6, 22.4], // Hawaii
        [-67.5, 17.8, -65.2, 18.6] // Puerto Rico
    ],
    ign: IGN_AREAS,
    ign_relief: IGN_AREAS
};

// National layer → the ISO country it covers.
const LAYER_COUNTRY = {
    ign: 'FR',
    ign_relief: 'FR',
    swiss_topo: 'CH',
    usgs_topo: 'US',
    os_maps: 'GB'
};

export const layerHasCoverage = (layer) => layer in COVERAGE;

// Does this base map have tiles at [lng, lat]? A world map, or an unknown centre, always does.
export const layerCoversPoint = (layer, center) => {
    const boxes = COVERAGE[layer];
    if (!boxes || !center) {
        return true;
    }

    const lng = ((((center[0] + 180) % 360) + 360) % 360) - 180;
    const lat = center[1];

    return boxes.some(([w, s, e, n]) => lng >= w && lng <= e && lat >= s && lat <= n);
};

// Picker order: MapPlanner then Outdoor (always first), the national maps of here (map centre, else the visitor country), the world
// maps, then the other countries' national maps — all listed, ties kept in the MapLayers order.
export const orderedMapLayers = (layers, {countryCode, center} = {}) => {
    const country = countryCode?.toUpperCase();
    const webOrder = Object.values(MapLayers);

    const rank = (layer) => {
        if (layer === MapLayers.MAP_PLANNER || layer === MapLayers.MAP_PLANNER_OUTDOOR) {
            return 0;
        }
        if (!layerHasCoverage(layer)) {
            return 2;
        }

        const isHere = center ? layerCoversPoint(layer, center) : false;

        return isHere || LAYER_COUNTRY[layer] === country ? 1 : 3;
    };

    return [...layers].sort((a, b) => rank(a) - rank(b) || webOrder.indexOf(a) - webOrder.indexOf(b));
};
